<template>
  <div id="actionBarWrapper"
       class="row white--text  primary-background align-content-center">
    <div class="col-12 text-right">
      <span> <i class="fas fa-long-arrow-right ml-3 action-bar-back bg-white round12px primary-text font16px cursor-pointer"  @click="goBack"></i></span>
      <span>{{ title }}</span>
    </div>

  </div>
</template>

<script>
export default {
  name: "ActionBar",
  props: ['title'],
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>
